module.exports = __webpack_public_path__ + "img/onetime.37d1bb5b.jpg";